var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-ajax-simple-table',{attrs:{"id":_vm.id,"header":_vm.header,"header-color":_vm.headerColor,"endpoint":_vm.endpoint,"endpoint-params":_vm.endpointParams,"rows":_vm.rows,"cols":_vm.cols,"bus":_vm.bus}})
}
var staticRenderFns = []

export { render, staticRenderFns }